<template>
    <van-tabbar :z-index="1998" v-model="innerActiveTab" @change="tabChanged" class="mw">
        <van-tabbar-item name="home">
            <img slot="icon" :class="innerActiveTab==='homeIndex'||innerActiveTab==='home'?'active':''"
                 :src="innerActiveTab==='homeIndex'||innerActiveTab==='home'?menu1_tab_active:menu1_tab">首页
        </van-tabbar-item>
        <van-tabbar-item name="product">
            <img slot="icon" :class="innerActiveTab==='productList'?'active':''"
                 :src="innerActiveTab==='productList'?menu2_tab_active:menu2_tab">产品
        </van-tabbar-item>
        <van-tabbar-item name="user">
            <img slot="icon" :class="innerActiveTab==='userIndex'?'active':''"
                 :src="innerActiveTab==='userIndex'?menu3_tab_active:menu3_tab">我的
        </van-tabbar-item>
    </van-tabbar>
</template>

<script>
    import { Tabbar, TabbarItem } from 'vant';
    import menu1_tab from '@/assets/images/menu/menu_home.png'
    import menu2_tab from '@/assets/images/menu/menu_list.png'
    import menu3_tab from '@/assets/images/menu/menu_my.png'
    import menu1_tab_active from '@/assets/images/menu/menu_home2.png'
    import menu2_tab_active from '@/assets/images/menu/menu_list2.png'
    import menu3_tab_active from '@/assets/images/menu/menu_my2.png'

    export default {
        props: {
            activeTab: String
        },
        components: {
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
        },
        data () {
            return {
                innerActiveTab: '',
                tabPath: {home: '/home', product: '/product/list', user: '/user/index'},
                menu1_tab: menu1_tab,
                menu2_tab: menu2_tab,
                menu3_tab: menu3_tab,
                menu1_tab_active: menu1_tab_active,
                menu2_tab_active: menu2_tab_active,
                menu3_tab_active: menu3_tab_active,
            }
        },
        watch: {
            $route (to, from) {
                this.setTabActive(to.path);
            }
        },
        mounted () {
        },
        methods: {
            tabChanged (tabName) {
                this.goUrl(this.tabPath[tabName]);
            },
            setTabActive (path) {
                console.log('>>>>>>>>>>>>>>>>>>>path', path)
                switch (path) {
                    case '/home':
                        this.innerActiveTab = 'homeIndex';
                        break;
                    case '/product/list':
                        this.innerActiveTab = 'productList';
                        break;
                    case '/user/index':
                        this.innerActiveTab = 'userIndex';
                        break;
                    default:
                        this.innerActiveTab = '';
                }
            },
            goUrl (path) {
                this.$router.push(path)
            }
        }
    }
</script>
<style lang="scss">

    .mw {
        max-width: 640PX !important;
        left: auto !important;
    }

    .van-tabbar-item {
        position: relative;
        .van-tabbar-item__text {
            position: absolute;
            bottom: 5px;
            left: 0;
            right: 0;
            text-align: center;
            color: #343434 !important;
        }
        .van-tabbar-item__icon {
            margin-bottom: 17px !important;
        }
        .active {
            height: 26px !important;
        }
    }

</style>
